<!-- <div *ngIf="reportType == 'InDetail-personalledger'">
  <div class="container" id="print-section" style="margin-top: 50px;">
    <table class="table table-bordered" style="width: 100%; border-collapse: collapse;">
      <thead>
        <tr>
          <th colspan="4" style="border: none; font-size: large;" class="br-bottom br-right">
            हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक
          </th>
          <th colspan="4" style="border: none; font-size: medium;" class="br-bottom br-right">
            Issue Seller Personal Ledger - In Details
          </th>
          <th colspan="3" style="border: none; font-size: small;" class="br-bottom br-right">
            Date: From {{ startDate | date: 'dd-MM-yyyy' }} - To {{ endDate | date: 'dd-MM-yyyy' }}
          </th>
          <th colspan="3" style="border: none; font-size: small;" class="br-bottom br-right">
            दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
          </th>
          <th colspan="4" style="border: none; font-size: small;" class="br-bottom br-right">
            
          </th>
        </tr>
        <tr>
          <th colspan="7" style="border: none; font-weight: bold; text-align: center; font-size: large;" class="br-bottom br-rightt">
            डेबिट
          </th>
          <th colspan="8" style="border: none; font-weight: bold; text-align: center; font-size: large;" class="br-bottom br-right">
            क्रेडिट
          </th>
          
        </tr>
        <tr>
          <th colspan="2" class="br-bottom br-right">Invoice No</th>
          <th colspan="2" class="br-bottom br-right">Invoice<br>Date</th>
          <th colspan="2" class="br-bottom br-right">Issue<br>Name</th>
          <th class="br-bottom br-rightt">Invoice<br>Amount</th>
          <th class="br-bottom br-right">Receipt<br>No</th>
          <th class="br-bottom br-right">Receipt<br>Date</th>
          <th class="br-bottom br-right">Credit<br>Voucher</th>
          <th class="br-bottom br-right">Bank<br>Details</th>
          <th class="br-bottom br-right">Invoice<br>Number</th>
          <th class="br-bottom br-right">Receipt Amt.</th>
          <th class="br-bottom br-right">Cr.Note Amt.</th>
          <th class="br-bottom">Balance</th>
        
        </tr>
      </thead>
      <tbody *ngFor="let data of getpersonalleddata; let i = index">
        <tr>
          <td colspan="15" style="font-size: 18px; border-bottom: 1px solid black; font-weight: bold; text-align: left;">
            Issue Seller Name: <span>{{ data.issue_seller_name }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="3" class="br-bottom br-top" style="font-size: small; font-weight: bold;">
            Opening Balance
          </td>
          <td colspan="9" class="br-bottom br-top" style="text-align: end; font-size: medium; font-weight: bold;">
            {{ data.opening_bal }} येणे
          </td>
          <td colspan="3" class="br-bottom br-top" style="font-size: small; font-weight: bold;">
            
          </td>
        </tr>
        <tr *ngFor="let data1 of data.rep_data; let k = index">
          <td colspan="2" class="br-right" style="font-size: small; white-space: nowrap;">{{ data1.invoice_no }}</td>
          <td colspan="2" class="br-right" style="font-size: small; white-space: nowrap;">{{ data1.invoice_date }}</td>
          <td colspan="2" class="br-right" style="font-size: small; white-space: nowrap;">{{ data1.issue_name }}</td>
          <td class="br-rightt" style="text-align: end; font-size: small; white-space: nowrap;">{{ data1.net_amt }}</td>
          <td class="br-right" style="font-size: small;">
            <div style="display: flex; flex-direction: column;">
              <span>{{ data1.rcpt_no }}</span>
              <span>{{ data1.credit_voc }}</span>
            </div>
          </td>
          <td class="br-right" style="font-size: small; text-align: center;">
            <div style="display: flex; flex-direction: column;">
              <span>{{ data1.rcpt_date }}</span>
              <span>{{ data1.voc_date }}</span>
            </div>
          </td>
          <td class="br-right" style="text-align: end; font-size: small; white-space: nowrap;">{{ data1.voucher_no }}</td>
          <td class="br-right" style="font-size: small; white-space: nowrap;">
            <ng-container *ngIf="data1.cheque_no || data1.pymt_options">
              <span>Cheque No: {{ data1.cheque_no }}</span><br>
              <span>Pay. Mode: {{ data1.pymt_options }}</span>
            </ng-container>
          </td>
          <td class="br-right" style="font-size: small; white-space: nowrap;">{{ data1.invoice_num }}</td>
          <td class="br-right" style="text-align: end; font-size: medium;">{{ data1.actual_arc_amt }}</td>
          <td class="br-right" style="text-align: end; font-size: medium;">{{ data1.credit_amt }}</td>
          <td class="br-bottom" style="text-align: end; font-size: medium;">
            <ng-container *ngIf="data1.bal_amt != null">
              {{ data1.act_amt }} येणे
            </ng-container>
          </td>
       
        </tr>
        <tr>
          <td colspan="3" class="br-top br-bottom br-right" style="text-align: end; font-weight: bold;">Total</td>
          <td class="br-top br-bottom br-rightt" style="text-align: end; font-weight: bold;">{{ data.invoice_total }}</td>
          <td colspan="5" class="br-top br-bottom br-right"></td>
          <td colspan="2" class="br-top br-bottom br-right" style="text-align: end; font-weight: bold;">{{ data.rcv_total }}</td>
          <td class="br-top br-bottom br-right" style="text-align: end; font-weight: bold;">{{ balancecfamt }}</td>
        </tr>
        <tr>
          <td colspan="3" class="br-bottom" style="font-weight: bold;">Balance C/F</td>
          <td class="br-bottom" style="text-align: end; font-weight: bold;">{{ balancecfamt }}</td>
          <td class="br-bottom" style="font-weight: bold;">येणे</td>
          <td colspan="7" class="br-bottom"></td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="margin-left: 70%; margin-bottom: 2%;" class="noPrint">
    <button class="noPrint" style="margin-top: 2%; margin-right: 10px;" (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
      Export
    </button>
    <button class="noPrint" style="margin-top: 2%; margin-left: 2%;" mat-raised-button color="primary" (click)="printPage3()">
      Print
    </button>
    <button class="noPrint" style="margin-top: 2%;" mat-button mat-dialog-close>
      Close
    </button>
  </div>
</div> -->

<div *ngIf="reportType == 'InDetail-personalledger'">
  <div class="container-fluid" id="print-section">
    <table class="table custom-table">
     <thead>
  <tr>
    <th colspan="3" class="large-text text-center">हिंदुस्थान प्रकाशन संस्था <br>- विवेक साप्ताहिक</th>
    <th colspan="4" class="medium-text text-center">Issue Seller <br>Personal Ledger - In Details</th>
    <th colspan="3" class="small-text text-center">
      Date: From {{ startDate | date: 'dd-MM-yyyy' }} <br>- To {{ endDate | date: 'dd-MM-yyyy' }}
    </th>
    <th colspan="2" class="small-text text-end">दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}</th>
  </tr>
  <tr>
    <th colspan="4" class="text-center bold large-text">डेबिट</th>
    <th colspan="8" class="text-center bold large-text">क्रेडिट</th>
  </tr>
  <tr>
    <th style="font-weight: bold;">Invoice No </th>
    <th style="font-weight: bold;">Invoice<br>Date</th>
    <th style="font-weight: bold;">Issue<br>Name</th>
    <th style="font-weight: bold;">Invoice<br>Amount</th>
    <th>Receipt<br>No</th>
    <th>Receipt<br>Date</th>
    <th>Credit<br>Voucher</th>
    <th>Bank<br>Details</th>
    <th>Invoice<br>Number</th>
    <th>Receipt Amt.</th>
    <th>Cr.Note Amt.</th>
    <th>Balance</th>
  </tr>
</thead>

      <tbody *ngFor="let data of getpersonalleddata; let i = index">
        <tr>
          <td colspan="12" class="section-header">Issue Seller Name: <span>{{ data.issue_seller_name }}</span></td>
        </tr>
        <tr>
          <td colspan="3" class="label-cell"style="background-color: #f0f9ff;">Deposit</td>
          <td colspan="9" class="value-cell text-end">{{ data.deposit }}</td>
        </tr>
        <tr>
          <td colspan="3" class="label-cell">Opening Balance</td>
          <td colspan="9" class="value-cell text-end">{{ data.opening_bal }} </td>
        </tr>

        <tr *ngFor="let data1 of data.rep_data; let k = index "style="background-color: #ffffff;"> 
          <td>{{ data1.invoice_no }}</td>
          <td>{{ data1.invoice_date }}</td>
          <td>{{ data1.issue_name }}</td>
          <td class="text-end">{{ data1.net_amt }}</td>
          <td>
            <div class="flex-column">
              <span>{{ data1.rcpt_no }}</span>
              <span>{{ data1.credit_voc }}</span>
            </div>
          </td>
          <td>
            <div class="flex-column">
              <span>{{ data1.rcpt_date }}</span>
              <span>{{ data1.voc_date }}</span>
            </div>
          </td>
          <td class="text-end">{{ data1.voucher_no }}</td>
          <td>
            <ng-container *ngIf="data1.cheque_no || data1.pymt_options">
              <span>Cheque No: {{ data1.cheque_no }}</span><br />
              <span>Pay. Mode: {{ data1.pymt_options }}</span>
            </ng-container>
          </td>
          <td>{{ data1.invoice_num }}</td>
          <td class="text-end">{{ data1.actual_arc_amt }}</td>
          <!-- <td class="text-end">{{ data1.rcv_total }}</td> -->
           <td class="text-end">{{ data1.credit_amt }}</td>
          <td class="text-end" *ngIf="data1.bal_amt != null">{{ data1.act_amt | number:'1.2-2' }} </td>
        </tr>

        
        <tr class="Invoice-total-row">
          <td colspan="3" class="text-end">Invoice Total</td>
          <td class="text-end">{{ data.total_invoice_amt }}</td>
          <td colspan="5"></td>
          <td class="text-end">{{ data.total_rcpt_amt }}</td>
          <td class="text-end">{{ data.total_credit_amt }}</td>
          <!-- <td class="text-end">{{ balancecfamt }}</td> -->
           <td></td>
        </tr>

        <tr class="total-row">
          <td colspan="3" class="text-end">Total</td>
          <td class="text-end">{{ data.invoice_total }}</td>
          <td colspan="5"></td>
          <td class="text-end">{{ data.rcv_amt }}</td>
          <td class="text-end">{{ data.rcv_total }}</td>
          <td class="text-end">{{ balancecfamt | number:'1.2-2' }}</td>
        </tr>

        <tr class="balance-row">
          <td colspan="3" class="label-cell">Balance C/F</td>
          <td class="text-end">{{ balancecfamt | number:'1.2-2'}}</td>
          <td class="label-cell"></td>
          <td colspan="7"></td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="action-buttons text-center">
    <button class="noPrint" (click)="exportExcel('Issue_seller_personal_ledger_Indetail_Report')" mat-raised-button color="primary">
      Export
    </button>
    <button class="noPrint" mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint style="margin: 0 15px;">
      Print
    </button>
    <button class="noPrint" mat-button mat-dialog-close style="margin: 0 15px;">
      Close
    </button>
  </div>
</div>


